export class GiftMallOrganisationRecord {
  constructor (record) {
    this.stock = record.stock
    this.entity = record.entity
    this.id = record.id
    this.title = record.title
    this.picture = record.picture
    this.allowSms = record.allowSms
    this.allowMail = record.allowMail
    this.allowPhysical = record.allowPhysical
  }
}



// WEBPACK FOOTER //
// ./src/js/records/giftmallorganisation.record.js